export default class HomeController {
  /* @ngInject */
  constructor(RouterService, MediaQueryService) {
    this.mediaQueryService = MediaQueryService;
    this.routerService = RouterService;
  }

  $onInit() {
    this.listenMediaQuery();
  }

  listenMediaQuery() {
    this.isDesktop = this.mediaQueryService.is('desktop');
    this.mediaQueryService.on('desktop', match => this.isDesktop = match);
  }

  $onDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.controller.js